import { Version } from '../../core/models/version'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import { RestQuery } from '../../rest/utilities/rest-query'
import {
  DynamicBinding,
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'
import { NoticeCategory } from './notice-category'
import { NoticeEngineer } from './notice-engineer'

export class Notice extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new Notice(), {
      firstVersion: new SerialisationConfig(() => new Version()),
      lastVersion: new SerialisationConfig(() => new Version()),
      currentVersion: new SerialisationConfig(() => new Version()),
      category: new SerialisationConfig(() => new NoticeCategory()),
      engineers: NoticeEngineer.serialisationConfig,
    })

  @alias('id')
  id!: number
  @alias('title')
  title!: string
  @alias('content')
  content!: string
  @alias('visibility')
  visibility!: string
  @alias('category')
  category!: NoticeCategory | null
  @alias('engineers')
  engineers!: NoticeEngineer[]
  @alias('opened_at')
  opened!: Date
  @alias('first_version')
  firstVersion!: Version | null
  @alias('latest_version')
  lastVersion!: Version | null
  @alias('current_version')
  currentVersion!: Version | null
  @alias('created_at')
  created!: Date
  @alias('updated_at')
  updated!: Date
  @alias('deleted')
  deleted!: boolean

  constructor() {
    super((Notice as unknown as AliasedConstructor)._alias)
  }

  get visibilityTitle(): string {
    return this.visibility === 'engineerSpecific'
      ? 'Engineer Specific'
      : 'Global'
  }

  override serialise(): object {
    const data = super.serialise() as DynamicBinding
    if (data['first_version']) {
      delete data['first_version']
    }
    if (data['last_version']) {
      delete data['last_version']
    }
    if (data['current_version']) {
      delete data['current_version']
    }
    if (Object.prototype.hasOwnProperty.call(data, 'category')) {
      data['category_id'] = this.category?.id ?? null
      delete data['category']
    }
    if (data['engineers']) {
      data['engineers'] = this.engineers.map(
        (engineer: NoticeEngineer) => engineer.id
      )
    }
    return data
  }

  static create<Data>(attrs: Data) {
    return new Notice().update(attrs, Notice.serialisationConfig)
  }
}

interface Filters {
  keywords?: string
  archive?: string
}
type Ordering = 'title' | '-title' | 'created_at' | '-created_at'
type Includes = 'category' | 'engineers' | 'accessLogs' | 'sendLogs'

export class NoticeQuery extends RestQuery<Filters, Ordering, Includes> {}
